(function () {
  function initStickyAtc() {
    var stickyBar = document.getElementById("sticky-atc-bar");
    if (!stickyBar) return;

    var mainBtn = document.querySelector(".product-form__submit");
    var footer = document.querySelector("footer");
    if (!mainBtn) return;

    var isMainBtnPast = false;
    var isFooterVisible = false;

    function updateBarVisibility() {
      if (isMainBtnPast && !isFooterVisible) {
        stickyBar.classList.add("sticky-atc-visible");
        stickyBar.classList.remove("sticky-atc-hidden");
      } else {
        stickyBar.classList.add("sticky-atc-hidden");
        stickyBar.classList.remove("sticky-atc-visible");
      }
    }

    var mainBtnObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        isMainBtnPast =
          !entry.isIntersecting && entry.boundingClientRect.top < 0;
        updateBarVisibility();
      });
    }, { threshold: 0 });
    mainBtnObserver.observe(mainBtn);

    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isFooterVisible = entry.isIntersecting;
          updateBarVisibility();
        });
      }, { threshold: 0 });
      footerObserver.observe(footer);
    }

    setTimeout(function () {
      stickyBar.classList.add("sticky-atc-initialized");
    }, 50);

    var stickyInput = document.getElementById("sticky-variant-id");
    var mainInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );
    var stickyBtn = document.getElementById("StickySubmitButton");
    var stickyBtnText = stickyBtn ? stickyBtn.querySelector(".btn-text") : null;

    var addToCartText =
      stickyBtn && stickyBtn.dataset.addToCartText
        ? stickyBtn.dataset.addToCartText
        : "Add to cart";
    var soldOutText =
      stickyBtn && stickyBtn.dataset.soldOutText
        ? stickyBtn.dataset.soldOutText
        : "Sold out";

    function syncVariant() {
      if (!mainInput || !stickyInput) return;

      var isDisabled = mainInput.disabled;
      if (stickyInput.value !== mainInput.value) {
        stickyInput.value = mainInput.value;
      }

      if (!stickyBtn) return;
      stickyBtn.disabled = isDisabled;

      if (stickyBtnText) {
        if (isDisabled) {
          stickyBtnText.textContent = soldOutText;
        } else {
          var priceEl = document.querySelector(
            ".price__regular .price-item--regular, .price-item--regular"
          );
          if (priceEl) {
            stickyBtnText.textContent =
              addToCartText + " – " + priceEl.textContent.trim();
          }
        }
      }
    }

    setInterval(syncVariant, 300);
    syncVariant();

    var stickyForm = document.getElementById("sticky-atc-form");
    if (stickyForm && stickyBtn) {
      stickyForm.addEventListener("submit", function () {
        stickyBtn.classList.add("loading");
        stickyBtn.disabled = true;
      });

      document.addEventListener("cart:updated", function () {
        stickyBtn.classList.remove("loading");
        syncVariant();
      });

      stickyForm.addEventListener("submit", function () {
        setTimeout(function () {
          stickyBtn.classList.remove("loading");
          syncVariant();
        }, 3000);
      });
    }
  }

  window.addEventListener("load", function () {
    setTimeout(initStickyAtc, 300);
  });
})();